import { render, staticRenderFns } from "./Modal_addSubcontract.vue?vue&type=template&id=4bca5ffc"
import script from "./Modal_addSubcontract.vue?vue&type=script&lang=js"
export * from "./Modal_addSubcontract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports